






import { Component, Vue } from "vue-property-decorator";
import PropertiesTiles from "@/components/property/PropertiesTiles.vue";
import PropertiesGrid from "@/components/property/PropertiesGrid.vue";
import GlobalFilterSensitiveMixin from '@/mixins/GlobalFilterSensitiveMixin';
import { Getter } from "vuex-class";

@Component({
  components: {
    PropertiesTiles,
    PropertiesGrid
  },
  mixins: [
    GlobalFilterSensitiveMixin
  ]
})
export default class PropertiesAndUnits extends Vue {
  @Getter("showGrid") showGrid?: boolean;
}
